/**
 * Global Warming Potential (GWP) factors
 * Source: Directive (EU) 2018/2001, paragraph 4 of Part C of Annex V
 */
export const GWP = {
  /** GWP factor for Carbon dioxide */
  CO2: 1,
  /** GWP factor for Methane */
  CH4: 25,
  /** GWP factor for Nitrous oxide */
  N2O: 298,
};

export const METRIC_TONNE_IN_GRAMS = 1_000_000;

/**
 * Calculate CO2 emissions in grams CO2eq
 */
export function calculateCo2Emissions(
  consumedBunkerTonnes: number,
  carbonFactor: number,
): number {
  return consumedBunkerTonnes * METRIC_TONNE_IN_GRAMS * carbonFactor * GWP.CO2;
}

/**
 * Calculate CH4 emissions in grams CO2eq
 */
export function calculateCh4Emissions(
  consumedBunkerTonnes: number,
  ch4Factor: number,
): number {
  return consumedBunkerTonnes * METRIC_TONNE_IN_GRAMS * ch4Factor * GWP.CH4;
}

/**
 * Calculate N2O emissions in grams CO2eq
 */
export function calculateN2oEmissions(
  consumedBunkerTonnes: number,
  n2oFactor: number,
): number {
  return consumedBunkerTonnes * METRIC_TONNE_IN_GRAMS * n2oFactor * GWP.N2O;
}
